import React from "react";
import { Section } from "./Section";
import {
  Banknote,
  HeartPulse,
  ShoppingBag,
  Factory,
  GraduationCap,
  Plane,
} from "lucide-react";

const INDUSTRIES = [
  { id: "ind-finance", icon: Banknote, label: "Finance & Banking" },
  { id: "ind-health", icon: HeartPulse, label: "Healthcare" },
  { id: "ind-retail", icon: ShoppingBag, label: "Retail & eCommerce" },
  { id: "ind-manuf", icon: Factory, label: "Manufacturing" },
  { id: "ind-edu", icon: GraduationCap, label: "Education" },
  { id: "ind-travel", icon: Plane, label: "Travel & Logistics" },
];

export const Industries = () => {
  return (
    <Section id="industries" className="bg-zinc-950 text-white py-24 lg:py-32">
      <div className="reveal-up max-w-2xl">
        <div className="text-xs uppercase tracking-[0.22em] text-[#FF4500] font-semibold">
          Industries we serve
        </div>
        <h2
          className="mt-4 text-4xl sm:text-5xl font-black tracking-[-0.02em] text-white"
          style={{ fontFamily: "Outfit, sans-serif" }}
        >
          Different industries.
          <br />
          <span className="text-zinc-500">Same uncompromising standard.</span>
        </h2>
      </div>

      <div className="mt-16 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-6 gap-px bg-white/10 border border-white/10 rounded-2xl overflow-hidden">
        {INDUSTRIES.map((ind) => {
          const Icon = ind.icon;
          return (
            <div
              key={ind.id}
              data-testid={ind.id}
              className="reveal-up bg-zinc-950 flex flex-col items-start gap-3 p-6 lg:p-8 hover:bg-zinc-900 transition-colors duration-200"
            >
              <Icon className="w-6 h-6 text-[#FF4500]" strokeWidth={1.75} />
              <span className="text-sm font-semibold text-white leading-snug">
                {ind.label}
              </span>
            </div>
          );
        })}
      </div>
    </Section>
  );
};

export default Industries;
